var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "center" },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("maintenancePage.title")))]),
        _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.$t("maintenancePage.description")))]),
          _c("p", { staticClass: "maintenance-date" }, [
            _vm._v(_vm._s(_vm.$t("maintenancePage.maintenancePeriod"))),
          ]),
        ]),
        _c("router-link", { attrs: { to: "/" } }, [
          _c("button", { staticClass: "button-top" }, [
            _vm._v(_vm._s(_vm.$t("maintenancePage.backToTop"))),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }